export default __webpack_public_path__ + "static/media/T23.791a0690.JPG";